// extracted by mini-css-extract-plugin
module.exports = {"container":"JobTable_container__gjmCM","table-container":"JobTable_table-container__3yz3O","header":"JobTable_header__2SwTQ","cancelBtn":"JobTable_cancelBtn__1teQ1"};